<template>
    <div id="j-wxpay-body" class="g-wxPay">
        <div class="m-wxpay">
            <div class="um-pay-wechat f-cb g-flow">
                <div class="um-pay-wechat_order_wrap m-panel" id="auto-id-1597288530692">
                    <div class="um-pay-wechat_order f-fs14" style="position: relative;">
                        <div class="um-pay-wechat_order_itm">
                            <span class="itm_title">实付金额：</span>
                            <span class="itm_content price">
                                <span class="yen">¥</span>
                                <span class="num">{{order_amount}}</span>
                            </span>
                        </div>
                        <div class="um-pay-wechat_order_itm">
                            <span class="itm_title">订 单 号：</span>
                            <span class="itm_content">{{sh_order_number}}</span>
                        </div>
                        <div class="um-pay-wechat_order_itm">
                            <span class="itm_title">订单状态：</span>
                            <span class="itm_content price order-state">
                                <span class="yen">待支付</span>
                            </span>
                        </div>
                        <div class="um-pay-wechat_order_tiktok">
                            请在提交订单后<span class="tiktok">2小时 </span>内付款，否则订单会被关闭

                            剩余时间：{{minute}} 分 {{second}} 秒
                        </div>
                        <a class="layui-btn layui-btn-danger back-btn" href="javascript:history.back(-1)"
                            style="position: absolute;right: 0;top: 0;display: none;">返回</a>
                    </div>
                </div>
                <div class="um-pay-wechat_qrcode_wrap m-panel" id="auto-id-1597288530693">
                    <div class="f-cb um-pay-wechat_qrcode_wrap_content">
                        <div class="f-fl qrcode_wrap_qrcode">
                            <div class="um-pay-wechat_qrcode f-fl">
                                <div class="um-pay-wechat_qrcode_title">微信支付</div>
                                <img class="um-pay-wechat_qrcode_img" :src="orderEwmUrl">
                                <div class="um-pay-wechat_qrcode_tip f-cb">
                                    <div class="qrcode_tip_img f-fl"></div>
                                    <div class="qrcode_tip_txt f-fl">请用微信扫一扫<br>扫描二维码支付</div>
                                </div>
                            </div>
                        </div>
                        <div class="f-fl qrcode_wrap_pic"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                order_amount: 0,
                sh_order_number: '',
                order_status: 0,
                orderEwmUrl: '',
                minute: 9,
                second: 60,
                state: 0
            }
        },
        destroyed() {

        },
        created() {

            this.state = this.$route.params.state;
            // 根据订单 id 获取订单详情
            let parames = new URLSearchParams();
            parames.append('orderId', this.$route.params.orderId);
            //获取 当前等级下的上传资料 列表
            this.$axios.post(this.serverUrl + '/getTradeOrder', parames).then(resp => {
                this.order_amount = resp.data.OrderRecord.order_amount;  //实际付款金额
                this.sh_order_number = resp.data.OrderRecord.sh_order_number;//订单号
                this.order_status = resp.data.OrderRecord.order_status;
                console.log(resp.data.OrderRecord.orderEwmUrl);
                this.orderEwmUrl = this.serverUrl + this.prefiexUrl + resp.data.OrderRecord.orderEwmUrl;//二维码路径
            }).catch(err => {
                this.$message({
                    showClose: true,
                    message: '服务器繁忙，稍后重试！',
                    type: 'error'
                });
            })

            this.countDown(this.second);

            let _this = this;
            setInterval(() => {
                _this.queryOrder();
            }, 5000);
        },
        methods: {
            //调取 订单查询接口
            queryOrder() {
                // 根据订单 id 获取订单详情
                let parames = new URLSearchParams();
                parames.append('orderId', this.$route.params.orderId);

                let urlStr = '';
                //判断是否为 综改区
                if (this.state == 1) {
                    urlStr = '/orderQuery';
                } else {
                    urlStr = '/orderQueryZG';
                }
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + urlStr, parames).then(resp => {

                    if (resp.data.code != 2) {
                        let StrMsg = '';
                        if (resp.data.code === 1) {
                            StrMsg = '支付成功！';
                        } else if (resp.data.code === 3) {
                            StrMsg = '该支付订单已关闭！';
                        } else if (resp.data.code === 4) {
                            StrMsg = '该支付订单已撤销！';
                        } else if (resp.data.code === 5) {
                            StrMsg = '支付失败！';
                        }
                        const loading = this.$loading({
                            lock: true,
                            text: StrMsg,
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        setTimeout(() => {
                            loading.close();
                            window.close();
                        }, 1500);
                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            countDown(second) {
                if (second === -1) {
                    if (this.minute === 0) {
                        const loading = this.$loading({
                            lock: true,
                            text: '付款倒计时结束！页面即将关闭！',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        setTimeout(() => {
                            loading.close();
                            window.close();
                        }, 1500);
                        return false;
                    }
                    this.minute--,
                        second = 60;
                }
                this.getSecond(second);
            },
            //发送验证码
            getSecond(second) {
                let _this = this;
                this.second = second;
                second--;
                setTimeout(function () { _this.countDown(second); },
                    1000);
            }
        }
    }
</script>

<style scoped>
    .um-pay-wechat .um-pay-wechat_qrcode_wrap {
        padding-left: 310px !important;
        height: 348px;
    }

    .um-pay-wechat .um-pay-wechat_qrcode_wrap .qrcode_wrap_pic {
        width: 193px;
        height: 295px;
        background: url(//mk.stu.126.net/res/module-order/pay/pay-wechat/phone_bg.png?1f104b9…) center top no-repeat;
    }

    .um-pay-wechat_qrcode .um-pay-wechat_qrcode_tip .qrcode_tip_txt {
        font-size: 12px;
    }

    .um-pay-wechat_qrcode .um-pay-wechat_qrcode_tip .qrcode_tip_img {
        margin-top: 3px;
        margin-right: 10px;
        width: 28px;
        height: 26px;
        background: url(//mk.stu.126.net/res/module-order/pay/pay-wechat/qr_icn.png?5b1a6ef…) center top no-repeat;
    }

    .um-pay-wechat_qrcode .um-pay-wechat_qrcode_tip {
        margin: 0 auto;
        width: 124px;
    }

    .um-pay-wechat_qrcode .um-pay-wechat_qrcode_img {
        margin: 20px 0 25px;
        width: 100%;
        height: 190px;
    }

    .um-pay-wechat_qrcode .um-pay-wechat_qrcode_title {
        line-height: 1;
        font-size: 18px;
    }

    .um-pay-wechat_qrcode {
        color: #333;
        width: 190px;
        text-align: center;
    }

    .f-fl {
        float: left;
    }

    .um-pay-wechat .um-pay-wechat_qrcode_wrap .qrcode_wrap_qrcode {
        margin-right: 136px;
    }

    .um-pay-wechat .um-pay-wechat_qrcode_wrap .um-pay-wechat_qrcode_wrap_content {
        margin-top: 30px;
    }

    .um-pay-wechat .m-panel {
        padding: 30px;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 3px;
        border-radius: 3px;
        background: #fff;
    }

    .um-pay-wechat .um-pay-wechat_qrcode_wrap {
        padding-left: 310px;
        height: 348px;
    }

    .um-pay-wechat_order .um-pay-wechat_order_tiktok .tiktok {
        margin: 0 6px;
        color: #f6454a;
    }

    .um-pay-wechat_order .um-pay-wechat_order_tiktok {
        margin-top: 23px;
        color: #333;
    }

    .um-pay-wechat_order .um-pay-wechat_order_itm .itm_content.price {
        color: #ff401a;
    }

    .um-pay-wechat_order .um-pay-wechat_order_itm .itm_title {
        width: 75px;
    }

    .um-pay-wechat_order .um-pay-wechat_order_itm {
        line-height: 28px;
    }

    .um-pay-wechat_order {
        color: #666;
    }

    .um-pay-wechat .m-panel {
        padding: 30px;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 3px;
        border-radius: 3px;
        background: #fff;
    }

    .um-pay-wechat .um-pay-wechat_order_wrap {
        margin-bottom: 20px;
        font-size: 14px;
    }

    .f-cb,
    .g-container {
        zoom: 1;
    }

    .g-wxPay {
        width: 1205px;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmPay.vue